/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S18_HeadingInputs */

const tr_mesafeli_s18_heading = /** @type {(inputs: Mesafeli_S18_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18. Tebligat`)
};

const en_mesafeli_s18_heading = /** @type {(inputs: Mesafeli_S18_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18. Notices`)
};

const de_mesafeli_s18_heading = /** @type {(inputs: Mesafeli_S18_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18. Zustellungen`)
};

const ru_mesafeli_s18_heading = /** @type {(inputs: Mesafeli_S18_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18. Уведомления`)
};

/**
* | output |
* | --- |
* | "18. Notices" |
*
* @param {Mesafeli_S18_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s18_heading = /** @type {((inputs?: Mesafeli_S18_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S18_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s18_heading(inputs)
	if (locale === "de") return de_mesafeli_s18_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s18_heading(inputs)
	return tr_mesafeli_s18_heading(inputs)
});